import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import appRouter from "@routes";
import "@styles/index.css";
import { Provider } from "react-redux";
import {store} from "@store";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <Provider store={store}>
  <React.StrictMode>
    <RouterProvider router={appRouter} />
  </React.StrictMode>
  </Provider>
);
